import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';

import * as constants from './constants';
import { StudentClessonResultStore, StudentClessonResultAction } from './typings';

const initialState: StudentClessonResultStore = {
    clessonResult: null,
};

const reducer = (state: StudentClessonResultStore = initialState, action: StudentClessonResultAction) => {
    // eslint-disable-next-line complexity
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.GET_STUDENT_CLESSON_RESULT_SUCCESS: {
                const { clessonId, result, studentId } = action;

                const newState = {
                    loadingStatus: LOADING_STATUSES.SUCCESS,
                    result,
                };

                if (!state.clessonResult) {
                    draft.clessonResult = {
                        [clessonId]: {
                            [studentId]: { ...newState },
                        },
                    };
                } else if (!state.clessonResult[clessonId]) {
                    draft.clessonResult![clessonId] = {
                        [studentId]: { ...newState },
                    };
                } else {
                    draft.clessonResult![clessonId][studentId] = { ...newState };
                }

                break;
            }

            case constants.CLEAR: {
                const { clessonId } = action;

                if (state.clessonResult && state.clessonResult[clessonId]) {
                    delete draft.clessonResult![clessonId];
                }

                break;
            }

            default:
                break;
        }
    });
};

export default reducer;
